<template>
    <div class="yuantext">
        员工账号设置
    </div>
    <div></div>
    <div class="riperpo">
        <table>
            <thead>
                <tr>
                    <th style="width: 200px;">名称</th>
                    <th style="width: 400px;">角色</th>
                    <th>操作</th>
                </tr>
            </thead>
            <tbody v-infinite-scroll="load" :infinite-scroll-immediate="false">
                <tr v-for="(item, index) in viplist" :key="index">
                    <td style="width: 200px;">
                        <div>{{ item.user.urealname || item.userName }}</div>
                        <div>ID:&nbsp;{{ item.userId }}</div>
                    </td>
                    <td style="width: 400px;">

                        <div>
                            <text v-for="(item2, index) in item.adminRoleList">{{ item2.roleName }}&nbsp;&nbsp;</text>
                        </div>
                    </td>
                    <td>
                        <div @click="xiugai(item)">修改权限</div>
                        <div @click="passwordCh(item)">修改密码</div>
                        <div @click="handleClose(item.userId)">删除</div>
                    </td>

                </tr>
            </tbody>
        </table>
    </div>
    <yc-mask ref="maskRef" :close-on-click-modal="false">
        <div class="roleadd" v-if="!ispasswordCh">
            <div class="dialogt">
                <div>
                    修改员工
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div class="numb">
                <div class="numbl">
                    <div class="numbmsg">
                        <div class="numt">真实姓名</div>
                        <div class="numbmsgtext">
                            <input type="text" v-model="realName">
                        </div>
                    </div>
                    <div class="numbmsg">
                        <div class="numt">账号</div>
                        <div class="numbmsgtext">
                            <input type="text" v-model="username">
                        </div>
                    </div>
                </div>
                <div class="numbr">
                    <div class="numbmsg">
                        <div class="bumeer" v-for="(item, index) in choosenumb" :key="index">
                            <div class="numt">选择第{{ index + 1 }}角色权限</div>
                            <div class="numbmsgtext">
                                <el-select v-model="value[index]" class="m-2" placeholder="请选择角色" size="large"
                                    @change="selectchange">
                                    <el-option class="optiontext" v-for="item2 in item.b" :key="item2.roleId"
                                        :label="item2.roleName" :value="item2.roleId" />
                                </el-select>

                                <!-- <div class="tianjia" v-if="index + 1 == choosenumb.length" @click="numbmsgadd">添加</div> -->
                                <div class="tianjias">
                                    <div class="tianjia" v-if="index + 1 == choosenumb.length && index != 3"
                                        @click="numbmsgadd">添加</div>
                                    <div class="tianjia" v-if="index + 1 == choosenumb.length && index != 0"
                                        @click="numbmsgremove">删除
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
            <div class="baochun" @click="baonumb">保存</div>
        </div>
        <div class="roleadd" v-if="ispasswordCh">
            <div class="dialogt">
                <div>
                    修改密码
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div class="numb">
                <div class="numbl">
                    <div class="numbmsg">
                        <div class="numt">真实姓名</div>
                        <div class="numbmsgtext">
                            <input type="text" v-model="realName" disabled='disabled'>
                        </div>
                    </div>
                    <div class="numbmsg">
                        <div class="numt">账号id</div>
                        <div class="numbmsgtext">
                            <input type="text" v-model="userId" disabled='disabled'>
                        </div>
                    </div>
                    <div class="numbmsg">
                        <div class="numt">新密码</div>
                        <div class="numbmsgtext">
                            <input type="text" v-model="newpassword" placeholder="请输入新密码">
                        </div>
                    </div>
                </div>
            </div>


            <div class="baochun" @click="baonumbs">保存</div>

        </div>
    </yc-mask>
</template>

<script setup>
import storeapi from '@/api/store'
import { ref, onMounted } from 'vue';
import { ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router';
import ycMask from '@/components/mask/mask.vue'
import store from '@/api/store'
import cloneDeep from 'lodash/cloneDeep';
import { ElMessage } from 'element-plus';
let seachkey = ref('')
let current = ref(1)
let viplist = ref([])

const router = useRouter()
onMounted(() => {
    pageAdmin()
    pageRole()
})

const load = async () => {
    console.log(';current', current.value)

    current.value++
    try {
        let data = {
            "keyword": seachkey.value,
            "keywordType": 1,
            "page": {
                "current": current.value,
                "pageSize": 5
            }
        }
        const res = await storeapi.pageAdmin(data)
        console.log(res)
        viplist.value.push(...res.data.records)
    } catch (error) {
        console.log(error)

    }
}
const pageAdmin = async () => {
    try {
        let data = {
            "keywordType": 0,
            "keyword": seachkey.value,
            "page": {
                "current": current.value,
                "pageSize": 5
            }
        }

        const res = await storeapi.pageAdmin(data)
        viplist.value = res.data.records
        console.log(viplist.value)

    } catch (error) {
        console.log(error)
    }
}
const handleClose = (userid) => {
    ElMessageBox.confirm('是否要删除该管理员?')
        .then(() => {
            console.log(222)
            delAdmin(userid)
        })
        .catch(() => {
            // catch error
            console.log(22333)
        })
}
const delAdmin = async (userid) => {
    const res = await storeapi.delAdmin(userid)
    if(res.success){
        current.value = 1
        pageAdmin()
   
    }
 
}
let records = ref([])
let password = ref('')
let passwordov = ref('')
let realName = ref('')
let username = ref('')
let userId = ref('')
let choosenumb = ref([])
let newpassword = ref('')
let value = ref([])
const ispasswordCh = ref(false)
const passwordCh = (peropo) => {
    realName.value = peropo.user.urealname
    username.value = peropo.user.uusername
    userId.value = peropo.userId
    ispasswordCh.value = true;
    maskRef.value.showMask();

}
const xiugai = async (peropo) => {
    console.log('peropo', peropo)
    ispasswordCh.value = false;
    let a = cloneDeep(peropo)
    choosenumb.value.push(...a.adminRoleList)
    // choosenumb.value = 
    realName.value = peropo.user.urealname
    username.value = peropo.user.uusername
    userId.value = peropo.userId
    if (choosenumb.value.length == 0) {
        let a = {
            b: records._rawValue,
            permIdList: [],
            permNode: null,
            roleDesc: "",

            roleName: "",


        }
        choosenumb.value.push(a)
    } else {

        for (let a = 0; a < choosenumb.value.length; a++) {
            choosenumb.value[a].b = records._rawValue
            value.value.push(choosenumb.value[a].roleId)

        }
    }

    console.log('choosenumb', choosenumb)
    console.log('value', value)

    maskRef.value.showMask();

}
const numbmsgadd = () => {
    if (choosenumb.value.length < 4) {
        let a = {
            b: records._rawValue
        }
        choosenumb.value.push(a)
    }

}
const numbmsgremove = () => {
    if (choosenumb.value.length > 1) {
        choosenumb.value.shift()
    }
}
const selectchange = (e) => {
    console.log(e)

    console.log(value._rawValue)
}


const pageRole = async () => {
    let data = {}
    const res = await store.pageRole(data)
    records.value = res.data.records
    console.log('records.value', records)

    console.log('records.value2', choosenumb.value)
}

const baonumb = async () => {
    console.log(realName, value, userId)
    let data = {
        realName: realName.value,
        roleIdList: value._rawValue,
        userId: userId.value
    }
    try {
        const res = await store.alterAdmin(data)
        console.log(res)
        if (res.success) {
            ElMessage({
                message: '修改角色成功.',
                type: 'success',
                duration: '800',
                onClose: () => {
                    router.go(0)
                }
            })
        } else {
            ElMessage.error(res.message)
        }
    } catch (error) {
        console.log(error)
    }
}
const baonumbs = async () => {
    try {
        if (newpassword.value.length < 1) {
            ElMessage({
                showClose: true,
                message: '请输入新的密码!',
                type: 'error',
            })
        } else {
            let data = {
                "password": newpassword.value,
                "userId": userId.value
            }
            const res = await store.alterAdminPwd(data)
            console.log(res)
            if (res.success) {
                ElMessage({
                    message: '修改密码成功.',
                    type: 'success',
                    duration: '800',
                    onClose: () => {
                        router.go(0)
                    }
                })
            } else {
                ElMessage({
                    showClose: true,
                    message: res.message,
                    type: 'error',
                })
            }
        }

    } catch (error) {
        console.log(error)
    }
}
//获取遮罩的实例
let maskRef = ref(null);

let closeDialog = () => {
    choosenumb.value = []
    value.value = []
    maskRef.value.closeMask();
};
</script>

<style lang="scss" scoped>
.yuantext {
    font-size: 16px;
    font-weight: 400;
    color: #111827;

}

tbody {
    display: block;
}

thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
}

.riperpo {
    margin-top: 21px;

    table {
        width: 100%;

        border-collapse: collapse;
        border-spacing: 0;

        thead {

            height: 46px;
            line-height: 46px;
            font-size: 14px;
            font-weight: 400;
            color: #4D585F;

            th {
                text-align: left;
                background: #EEEEEE;
                box-sizing: border-box;
            }

            th:first-child {

                width: 200px;
                border-radius: 8px 0 0 8px;
                padding-left: 24px;
                box-sizing: border-box;
            }

            th:last-child {

                border-radius: 0 8px 8px 0;
            }
        }

        tbody {
            width: 100%;
            height: 400px;
            overflow-y: scroll;

            tr {
                text-align: center;
                font-size: 16px;
                font-weight: 400;
                color: #718096;

                td {
                    height: 87px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #E9E9E9;
                    padding-top: 24px;
                    vertical-align: middle;
                    text-align: left;

                }

                td:last-child {
                    font-size: 14px;
                    font-weight: 400;
                    color: #1890FF;

                    div {
                        margin-right: 33px;

                        float: left;
                        cursor: pointer;
                    }

                    // div:last-child {
                    //     margin-left: 33px;
                    // }

                }

                td:first-child {
                    padding: 21px 0 0 20px;
                    width: 100px;
                    text-align: left;

                    line-height: 20px;
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.65);

                    div:last-child {
                        margin-top: 6px;
                        color: rgba(0, 0, 0, 0.45);
                        font-weight: 400;
                    }

                }
            }
        }
    }

}

.roleadd {
    position: relative;
    width: 388px;
    height: 555px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 23px 36px 0 35px;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 13px;
    }

    .numb {
        width: 100%;
        overflow: auto;
        // background-color: #ff18f3;
        height: 410px;

        .numbl {
            box-sizing: border-box;

            .numbmsg {
                width: 332px;
                font-size: 14px;
                color: #718096;
                margin-bottom: 13px;

                .numt {
                    margin-bottom: 12px;
                }

                .numbmsgtext {
                    width: 100%;
                    height: 56px;
                    background: #FAFAFA;
                    padding: 0 14px 0 14px;
                    box-sizing: border-box;


                    .m-2 {
                        width: 100% !important;
                        background: #FAFAFA;
                        height: 56px;
                    }

                    input {
                        height: 56px;
                        padding: 0;
                    }
                }

            }
        }

        .numbr {

            .numbmsg {
                font-size: 14px;
                color: #718096;
                margin-bottom: 13px;


                .bumeer:first-child {
                    margin-top: 0px;
                }

                .bumeer {
                    margin-top: 13px;

                    .numt {
                        margin-bottom: 12px;
                    }

                    .numbmsgtext {
                        width: 372px;
                        height: 56px;

                        display: flex;
                        align-items: center;

                        .tianjias {
                            display: flex;
                            justify-content: space-around;
                            flex-direction: column;
                            height: 100%;

                            .tianjia {
                                font-weight: 400;
                                color: #418EFF;
                                margin-left: 9px;
                                cursor: pointer;
                            }
                        }


                        .m-2 {
                            width: 90% !important;
                            background: #FAFAFA;
                            height: 56px;

                            .select-trigger {
                                height: 56px !important;
                            }
                        }
                    }

                }
            }

        }
    }

    .baochun {
        width: 96px;
        height: 48px;
        background: #79AFFF;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 48px;
        text-align: center;
        margin: 15px auto;
    }
}
</style>